import { render, staticRenderFns } from "./PolicyOther.vue?vue&type=template&id=4b76e9b4&"
import script from "./PolicyOther.vue?vue&type=script&lang=js&"
export * from "./PolicyOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports